import { render, staticRenderFns } from "./ReasonSelector.vue?vue&type=template&id=24ba4ce8&scoped=true&"
import script from "./ReasonSelector.vue?vue&type=script&lang=js&"
export * from "./ReasonSelector.vue?vue&type=script&lang=js&"
import style0 from "./ReasonSelector.vue?vue&type=style&index=0&id=24ba4ce8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ba4ce8",
  null
  
)

export default component.exports